<form *ngIf="!loading" class="k-form" [formGroup]="form">
  <fieldset class="k-form-fieldset">
    <legend class="k-form-legend">{{ 'step_forInformation_new_name' | i18n }}</legend>
    <kendo-formfield showHint="initial" showErrors="initial">
      <kendo-label [for]="title" [text]=" 'step_new_label_title' | i18n "></kendo-label>
      <input kendoTextBox formControlName="title" #title required />
      <kendo-formhint>{{ 'step_new_formhint_title' | i18n }}</kendo-formhint>
      <kendo-formerror>
        <div *ngIf="form.controls.title.errors?.required">{{ 'step_new_formerror_title' | i18n }}</div>
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield showErrors="initial">
      <kendo-label [for]="responsible" [text]="'step_details_responsible' | i18n"></kendo-label>
      <sp-people-picker #responsible formControlName="responsible"></sp-people-picker>
      <kendo-formerror>
        <div *ngIf="form.controls.responsible.errors?.required">{{'step_new_formerror_responsible' | i18n }}</div>
      </kendo-formerror>
    </kendo-formfield>
    <common-switch-form-field [form]="form"></common-switch-form-field>
    <kendo-formfield showErrors="initial">
      <kendo-label [for]="comment" [text]="'step_details_comment' | i18n"></kendo-label>
      <textarea kendoTextArea formControlName="comment" #comment [autoSize]="true"></textarea>
      <kendo-formerror>
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield [showErrors]="'initial'">
      <kendo-label [for]="dueDate" [text]="'step_new_label_dueDate' | i18n"></kendo-label>
      <kendo-datepicker [title]="'step_new_label_dueDate' | i18n" #dueDate [formControlName]="'dueDate'" required [min]="minDueDate$ | async" [max]="maxDueDate$ | async"></kendo-datepicker>
      <kendo-formhint>{{ 'step_new_formhint_dueDate' | i18n }}</kendo-formhint>
      <kendo-formerror>
        <div *ngIf="form.controls.dueDate.errors?.required">{{ 'step_new_formerror_dueDate_required' | i18n }}</div>
        <div *ngIf="form.controls.dueDate.errors?.range?.before">{{ 'step_new_formerror_dueDate_before_range' | i18n:form.controls.dueDate.errors.range}}</div>
        <div *ngIf="form.controls.dueDate.errors?.range?.after">{{ 'step_new_formerror_dueDate_after_range' | i18n:form.controls.dueDate.errors.range}}</div>
      </kendo-formerror>
    </kendo-formfield>

    <step-permissions [form]="form"></step-permissions>

    <div class="k-form-buttons">
      <ece-btn-primary (click)="save()" [text]=" 'step_new_button_save' | i18n "></ece-btn-primary>
      <ece-btn (click)="abort()" [text]=" 'step_new_button_abort' | i18n"></ece-btn>
      &nbsp;
      <ece-btn (click)="delete()" [text]=" 'step_edit_button_delete' | i18n"></ece-btn>
    </div>
  </fieldset>
</form>
